import styled from "styled-components";
import {
  space,
  color,
  layout,
  typography,
  position,
  variant,
  flexbox,
} from "styled-system";
import propTypes from "@styled-system/prop-types";
import { Icon as I } from "../../components/Icon";

const Icon = styled(I)`
  ${space};
  ${color};
  ${layout};
  ${typography};
  ${position};
  ${flexbox};
  ${props =>
    variant({
      variants: {
        button: {
          position: "absolute",
          top: "50%",
          left: "15px",
          transform: "translateY(-50%)",
        },
      },
    })}
`;

Icon.displayName = "Icon";

Icon.defaultProps = {
  display: "inline-block",
  fontSize: 2,
  fontWeight: "normal",
};

Icon.propTypes = {
  ...propTypes.space,
  ...propTypes.color,
  ...propTypes.layout,
  ...propTypes.typography,
  ...propTypes.position,
};

export default Icon;
